export const newsItems = [
  {
    id: 'news-1',
    type: 'news',
    title: '《我的朋友他的妻子》收官：一场关于"体面"的集体复盘',
    subtitle: '剧评｜当三个人都不肯先开口',
    excerpt:
      '剧集在昨日收官。最后一集没有反转、没有和解，只留下一个空掉的吧台。正是这种克制，让它在同期作品中留下了最长的讨论余温。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20empty%20bar%20counter%20at%20dawn%20with%20a%20single%20neatly%20folded%20white%20towel%2C%20warm%20amber%20light%20spilling%20across%20polished%20wood%2C%20rows%20of%20bottles%20in%20soft%20focus%2C%20deep%20charcoal%20shadows%2C%20dust%20motes%2C%20quiet%20aftermath%20mood%2C%20film%20grain%2C%20elegant%20widescreen%20composition&width=1200&height=700&seq=news-scene-01&orientation=landscape',
    date: '2025-05-06',
    dateLabel: '2025.05.06',
    weight: 99,
    tags: ['剧评', '收官', '主题分析'],
    meta: [
      { label: '栏目', value: '剧集评论' },
      { label: '发布时间', value: '2025 年 5 月 6 日' },
      { label: '关键词', value: '收官 / 克制 / 留白' },
    ],
    quote: '它没有替观众做决定，所以观众才会一直讨论。',
    body: [
      '《我的朋友他的妻子》在昨晚播完最后一集。没有追车，没有雨中的奔跑，没有多年后的重逢。最后一个镜头是清晨的酒吧，灯亮着，柜台后面没有人。',
      '这种处理方式在当下的剧集市场里是冒险的。观众习惯了情绪被推到最高点再释放，而这部剧选择了相反的路径：把音量一路调低，直到只剩下呼吸声。',
      '讨论度最高的并不是感情线，而是三个人各自的"体面"。陈默用沉默维持朋友的身份，江暖用得体维持婚姻的秩序，陆嘉行用道理维持一个家。三个人都在做正确的事，结果是所有人都没有过好。',
      '编剧在采访中说，这个结局不是悲剧，是"成年人的平均结果"。观众是否认同，或许取决于你在生活里更常扮演哪一个角色。',
    ],
  },
  {
    id: 'news-2',
    type: 'news',
    title: '第八集海边长镜头幕后：那一条拍了整整十九次',
    subtitle: '幕后｜风太大，两个人都听不清对方',
    excerpt:
      '被称为"全剧最佳三分钟"的海边对话，实际拍摄时遇到了七级海风。两位演员最后靠手势完成走位，台词全部后期重录。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20film%20still%20of%20a%20film%20crew%20on%20an%20overcast%20beach%20at%20dusk%20with%20camera%20rig%20and%20windbreakers%2C%20two%20actors%20standing%20far%20apart%20in%20the%20background%2C%20wet%20sand%20and%20low%20waves%2C%20grey%20golden%20light%2C%20muted%20moody%20tones%2C%20film%20grain%2C%20documentary%20style%20wide%20shot&width=1200&height=700&seq=news-scene-02&orientation=landscape',
    date: '2025-04-24',
    dateLabel: '2025.04.24',
    weight: 94,
    tags: ['幕后', '海边', '拍摄'],
    meta: [
      { label: '栏目', value: '幕后故事' },
      { label: '发布时间', value: '2025 年 4 月 24 日' },
      { label: '关键词', value: '长镜头 / 海风 / 同期声' },
    ],
    quote: '导演说，风是真的，所以别演风。',
    body: [
      '这场戏在南方一处防波堤拍摄，原计划一天完成。结果海风持续加强，收音几乎全部失败，剧组只能把台词改成后期重录。',
      '摄影指导坚持保留自然光，把拍摄窗口压缩在日落前后的四十分钟。这意味着每一条都必须一次成功，否则要等第二天。',
      '两位演员在风中站了六个小时。苏婉宁后来回忆，因为听不清对方说话，他们索性不看台词，只看对方的口型，"反而更准"。',
      '最终成片用的是第十九条。导演说，前十八条都在"演一段关系"，只有第十九条，是两个人在风里真的说完了话。',
    ],
  },
  {
    id: 'news-3',
    type: 'news',
    title: '林知远谈陈默：这个角色最难的地方是"不解释"',
    subtitle: '专访｜沉默是一种表演选择',
    excerpt:
      '在最新一次专访中，林知远聊到了他对陈默的理解，也聊到了为什么主动删掉了近三分之一的台词。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20interview%20scene%20still%20of%20a%20man%20sitting%20in%20a%20dim%20rehearsal%20room%20lit%20by%20a%20single%20warm%20practical%20lamp%2C%20empty%20chairs%20and%20a%20script%20on%20the%20table%2C%20deep%20charcoal%20walls%2C%20amber%20pool%20of%20light%2C%20thoughtful%20quiet%20atmosphere%2C%20film%20grain%2C%20editorial%20cinematic%20framing&width=1200&height=700&seq=news-scene-03&orientation=landscape',
    date: '2025-04-18',
    dateLabel: '2025.04.18',
    weight: 90,
    tags: ['专访', '林知远', '表演'],
    meta: [
      { label: '栏目', value: '演员专访' },
      { label: '发布时间', value: '2025 年 4 月 18 日' },
      { label: '关键词', value: '林知远 / 陈默 / 台词' },
    ],
    quote: '解释是给观众的，沉默是给角色的。',
    body: [
      '林知远说，他第一次读完剧本时，最不适应的就是陈默的"不行动"。这个人明明有机会说清楚，却一次次选择把话咽回去。',
      '为了找到理由，他给角色写了一段不拍出来的前史：十九岁那年，陈默曾经试图解释一次，结果失去了一个朋友。从那以后他就不解释了。',
      '谈到删台词的争议，他表示这是和导演共同的决定："我们不希望观众被台词牵着走。观众愿意多想一步，这个角色才成立。"',
      '被问到会不会遗憾结局没有给出明确答案，他笑了一下说：生活里也没有人给我发过结局。',
    ],
  },
  {
    id: 'news-4',
    type: 'news',
    title: '美术组公开场景手稿：旧城酒吧其实只有三面墙',
    subtitle: '制作｜一个被反复使用的空间',
    excerpt:
      '剧组公布了"归途"酒吧的场景手稿。这个贯穿全剧的空间，实际搭建时只有三面墙，第四面永远留给摄影机。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20set%20construction%20still%20of%20a%20small%20vintage%20bar%20built%20inside%20a%20studio%2C%20wooden%20counter%20and%20shelves%20of%20bottles%2C%20exposed%20lighting%20rig%20above%2C%20warm%20amber%20practical%20lamps%2C%20deep%20shadows%2C%20blue%20free%20warm%20palette%2C%20film%20grain%2C%20documentary%20production%20photography&width=1200&height=700&seq=news-scene-04&orientation=landscape',
    date: '2025-04-11',
    dateLabel: '2025.04.11',
    weight: 82,
    tags: ['制作', '美术', '场景'],
    meta: [
      { label: '栏目', value: '制作揭秘' },
      { label: '发布时间', value: '2025 年 4 月 11 日' },
      { label: '关键词', value: '场景设计 / 手稿 / 光影' },
    ],
    quote: '空间越窄，人物之间的距离就越清楚。',
    body: [
      '"归途"酒吧是全剧出现频率最高的场景，共出现四十七次。美术组透露，实际搭建面积不到六十平方米，且只有三面完整的墙。',
      '为了让空间不显得局促，灯光组在吊顶藏了十六盏可调光的小灯，靠明暗变化制造不同的时间感。同一个空间，黄昏、深夜、清晨用的是三套完全不同的光比。',
      '手稿上还标注了很多不会拍到的细节：墙上那张褪色的演出海报、柜台下的旧唱片、门后挂着的两把伞。',
      '美术指导说，这些细节存在的意义不是被看见，而是让演员相信这个地方真的有人住过。',
    ],
  },
  {
    id: 'news-5',
    type: 'news',
    title: '编剧回应"三观争议"：这个剧本不打算给出道德结论',
    subtitle: '回应｜关于角色选择的讨论',
    excerpt:
      '面对观众对角色关系的激烈讨论，编剧在社交平台发文回应，表示剧本从一开始就不打算评判任何人。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20screenwriter%20desk%20at%20night%20with%20a%20stack%20of%20annotated%20screenplay%20pages%2C%20reading%20glasses%2C%20a%20cup%20of%20cold%20tea%2C%20single%20warm%20desk%20lamp%2C%20deep%20charcoal%20room%2C%20amber%20pool%20of%20light%2C%20paper%20texture%20detail%2C%20film%20grain%2C%20intimate%20nocturnal%20mood&width=1200&height=700&seq=news-scene-05&orientation=landscape',
    date: '2025-04-02',
    dateLabel: '2025.04.02',
    weight: 88,
    tags: ['回应', '编剧', '争议'],
    meta: [
      { label: '栏目', value: '行业动态' },
      { label: '发布时间', value: '2025 年 4 月 2 日' },
      { label: '关键词', value: '编剧 / 争议 / 创作谈' },
    ],
    quote: '写一个正确的人很容易，写一个真实的人很难。',
    body: [
      '编剧在长文中写道，这个故事的起点是一个问题：如果三个人都没有做错什么，为什么大家都不幸福。',
      '对于"是否美化越界关系"的质疑，他回应：剧集没有给任何人颁奖，也没有给任何人定罪。观众看到的不适，恰恰是创作想保留的部分。',
      '他透露剧本改了七稿，最初版本里有一个明确的"坏人"，后来被彻底删掉。因为一旦有坏人，剩下的两个人就自动成了受害者，故事也就失去了重量。',
      '文章最后一句是：如果这部剧让你在某个瞬间想起了自己，那它就已经完成了任务。',
    ],
  },
  {
    id: 'news-6',
    type: 'news',
    title: '配乐特辑上线：一把大提琴撑起的十二集',
    subtitle: '音乐｜主创谈"少即是多"',
    excerpt:
      '全剧配乐仅使用了十二件乐器，主题旋律在不同集数中被拆解成碎片，直到最后一集才完整出现。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20cellist%20recording%20in%20a%20dim%20studio%20with%20a%20microphone%20and%20warm%20amber%20lamp%2C%20close%20detail%20on%20the%20bow%20and%20strings%2C%20deep%20charcoal%20acoustic%20panels%20in%20background%2C%20dust%20in%20the%20light%20beam%2C%20film%20grain%2C%20intimate%20sessions%20atmosphere&width=1200&height=700&seq=news-scene-06&orientation=landscape',
    date: '2025-03-27',
    dateLabel: '2025.03.27',
    weight: 76,
    tags: ['音乐', '配乐', '制作'],
    meta: [
      { label: '栏目', value: '制作揭秘' },
      { label: '发布时间', value: '2025 年 3 月 27 日' },
      { label: '关键词', value: '配乐 / 大提琴 / 主题旋律' },
    ],
    quote: '主题旋律不是没写完，是一直在等一个合适的位置。',
    body: [
      '配乐特辑公开了全剧的音乐结构：十二集共用一段主题旋律，但每一集只出现其中两个小节，且调性各不相同。',
      '作曲解释说，这是为了制造"熟悉又抓不住"的感觉。观众会觉得某段旋律听过，却始终无法完整哼出来——就像剧中人物对过去的记忆。',
      '直到终章，完整旋律才第一次出现，由一把大提琴独奏，时长两分十一秒，没有加入任何其他乐器。',
      '录音时，演奏者被要求不要追求完美音准。作曲说，我们要的不是漂亮，是那种"手在抖"的真实感。',
    ],
  },
  {
    id: 'news-7',
    type: 'news',
    title: '取景地走访：那条被雨水洗亮的旧街在哪里',
    subtitle: '场景｜一条即将改造的老街',
    excerpt:
      '剧中最常出现的旧街取景于南方一座老城区。剧组拍摄结束后不久，该片区宣布启动改造，这些画面因此成了记录。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20narrow%20old%20southern%20Chinese%20street%20at%20dusk%20after%20rain%2C%20neon%20shop%20signs%20reflecting%20in%20puddles%2C%20weathered%20concrete%20buildings%20with%20air%20conditioners%2C%20warm%20amber%20light%20against%20deep%20charcoal%20shadows%2C%20lonely%20atmosphere%2C%20film%20grain%2C%20wide%20cinematic%20framing&width=1200&height=700&seq=news-scene-07&orientation=landscape',
    date: '2025-03-20',
    dateLabel: '2025.03.20',
    weight: 72,
    tags: ['取景地', '旧城', '记录'],
    meta: [
      { label: '栏目', value: '场景走访' },
      { label: '发布时间', value: '2025 年 3 月 20 日' },
      { label: '关键词', value: '取景地 / 老城区 / 城市记忆' },
    ],
    quote: '我们拍下的不是布景，是一条正在消失的街。',
    body: [
      '剧中反复出现的旧街位于南方某老城区，全长不到四百米，两侧是上世纪八十年代的居民楼。',
      '制片组透露，选择这里是因为"雨后的反光特别好看"。为了等一场合适的雨，剧组在这里连续待了九天。',
      '拍摄结束三个月后，该片区发布改造公告。摄影指导在社交平台写道：现在回看，那些镜头更像是记录，而不是设计。',
      '不少观众在剧集播出后前往打卡，当地居民在采访中说，没想到自己住了一辈子的巷子，会在电视里那么好看。',
    ],
  },
  {
    id: 'news-8',
    type: 'news',
    title: '主创圆桌：我们为什么坚持不给一个"爽"的结尾',
    subtitle: '圆桌｜导演、编剧、摄影指导对谈',
    excerpt:
      '在收官圆桌中，三位主创聊到了结局的取舍、观众的期待，以及为什么最后一集刻意减少了所有音乐。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20three%20empty%20chairs%20around%20a%20table%20in%20a%20dim%20screening%20room%2C%20faint%20projector%20beam%20cutting%20through%20the%20darkness%2C%20warm%20amber%20light%20from%20a%20doorway%2C%20deep%20charcoal%20walls%2C%20atmospheric%20dust%2C%20film%20grain%2C%20quiet%20reflective%20mood&width=1200&height=700&seq=news-scene-08&orientation=landscape',
    date: '2025-03-13',
    dateLabel: '2025.03.13',
    weight: 80,
    tags: ['圆桌', '主创', '创作'],
    meta: [
      { label: '栏目', value: '主创对谈' },
      { label: '发布时间', value: '2025 年 3 月 13 日' },
      { label: '关键词', value: '结局 / 创作取舍 / 声音设计' },
    ],
    quote: '爽是即时的，余味是延迟的。我们选了后者。',
    body: [
      '导演在圆桌开场说，从第一稿开始，结局就没有变过：不解释、不团圆、不告别。',
      '摄影指导提到，最后一集几乎撤掉了所有配乐，只保留环境音。"观众需要听见自己的呼吸，才不会觉得被故事推着走。"',
      '面对"是否担心观众不满"的提问，编剧回答：担心，但更担心写一个自己都不相信的结尾。',
      '三人最后聊到了续集的可能。导演说，这个故事已经说完了，但如果有一天要拍，他会从老魏的视角重新讲一遍。',
    ],
  },
];